import React from 'react';
import { getPublicPath } from 'lib/utils';

import Box from 'components/react-styled-core/Box';
import Image from 'components/react-styled-core/Image';
import {
    Dropdown,
    Toggle,
    Menu,
    MenuItem,
} from 'components/Dropdown';

const LanguageDropdown = ({ lang = 'en', onSelect }) => {
    const publicPath = getPublicPath();
    const LANGUAGE = {
        'en': 'English',
        'it': 'Italiano',
        'es': 'Español',
        'pt': 'Português',
        'el': 'Ελληνικά',
    };

    return (
        <Box
            position="absolute"
            top="0"
            right="6x"
            bg="white"
        >
            <Dropdown
                onSelect={onSelect}
            >
                <Toggle
                    btnStyle="flat"
                    style={{ background: '#ffffff' }}
                >
                    <Box
                        display="inline-block"
                        verticalAlign="top"
                        mr="2x" // 8px
                    >
                        <Image src={`${publicPath}images/icon_sphere.svg`} />
                    </Box>
                    {LANGUAGE[lang] || LANGUAGE.en}
                </Toggle>
                <Menu>
                    <MenuItem
                        eventKey="en"
                        active={lang === 'en'}
                    >
                        {LANGUAGE.en}
                    </MenuItem>
                    <MenuItem
                        eventKey="it"
                        active={lang === 'it'}
                    >
                        {LANGUAGE.it}
                    </MenuItem>
                    <MenuItem
                        eventKey="es"
                        active={lang === 'es'}
                    >
                        {LANGUAGE.es}
                    </MenuItem>
                    <MenuItem
                        eventKey="pt"
                        active={lang === 'pt'}
                    >
                        {LANGUAGE.pt}
                    </MenuItem>
                    <MenuItem
                        eventKey="el"
                        active={lang === 'el'}
                    >
                        {LANGUAGE.el}
                    </MenuItem>
                </Menu>
            </Dropdown>
        </Box>
    );
};

export default LanguageDropdown;
